import { Table } from 'antd';
import qs from 'qs';
import { useEffect, useState, React } from 'react';
import EditModal from './Modal_example';
const columns = [
  {
    title: 'id',
    dataIndex: 'name',
    sorter: true,
    render: () => `${Math.floor(Math.random() * 100)}`,
    width: '5%',
  },
  {
    title: 'id',
    dataIndex: '',
    sorter: true,
    render: (rowKey) => {
      // console.log(rowKey);
      return (
        <EditModal
          edit1={rowKey.name.first}
          edit2={rowKey.name.last}
          edit3={rowKey.phone}
          edit4={rowKey.email}
          edit5={rowKey.gender}
        />
      );
    },
    width: '10%',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: true,
    render: (name) => `${name.first} ${name.last}`,
    width: '20%',
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    filters: [
      {
        text: 'Male',
        value: 'male',
      },
      {
        text: 'Female',
        value: 'female',
      },
    ],
    width: '20%',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
];
const getRandomuserParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});
const Table_example2 = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  useEffect(() => {
    const intlTableParams = {
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
    const fetchData = () => {
      setLoading(true);
      fetch(
        `https://randomuser.me/api?${qs.stringify(
          getRandomuserParams(intlTableParams)
        )}`
      )
        .then((res) => res.json())
        .then(({ results }) => {
          setData(results);
          setLoading(false);
          setTableParams({
            ...intlTableParams,
            pagination: {
              ...intlTableParams.pagination,
              total: 200,
              // 200 is mock data, you should read it from server
              // total: data.totalCount,
            },
          });
        });
    };
    fetchData();
  }, []);
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  return (
    <fieldset>
      <legend style={{ width: 'auto', marginLeft: '100px', border: 'none' }}>
        表格區域（包含刪除按鈕）和Modal結合 會跳出該欄位的消息
      </legend>
      <Table
        columns={columns}
        rowKey={(record) => record.login.uuid}
        dataSource={data}
        pagination={tableParams.pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </fieldset>
  );
};
export default Table_example2;
